import { floorplansApi } from './client'

export function getFloorplans() {
  return floorplansApi.getFloorplans()
}
